import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { isAnalyticsEnabled } from '~/config/analytics';
import type {} from '~/lib/trackAnalyticsEvent';

/** SPA の画面遷移ごとに GA4 へ page_view を送信する */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    if (
      !isAnalyticsEnabled ||
      typeof window === 'undefined' ||
      typeof window.gtag !== 'function'
    ) {
      return;
    }

    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
};
